import { postRequest } from "../../shared/api/axiosHandler";

export const sendContactUsEmail = async (data) => {
  try {
    return await postRequest('/public/customer/contact', data);
  } catch (error) {
    throw error;
  }
}
